import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'

import { App } from './app/App'
import './estilos/tema.css'

const clienteQuery = new QueryClient({
  defaultOptions: {
    queries: {
      // O conteúdo dos 28 dias muda pouco; o que muda é o registro dela.
      staleTime: 5 * 60 * 1000,
      gcTime: 24 * 60 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
      // Sem rede, servir o cache em vez de mostrar erro.
      networkMode: 'offlineFirst',
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
})

// O service worker é o que faz o push chegar. Atualiza sozinho: pedir
// confirmação de atualização a quem só quer marcar o diário é atrito
// desnecessário. sw.ts já faz skipWaiting + clients.claim() sem
// perguntar — o que falta é o navegador CHECAR se há uma versão nova.
//
// Isso não acontece com a frequência que a gente gostaria: um PWA
// trazido de volta do segundo plano nem sempre conta como "navegação"
// para o navegador, e o intervalo padrão de checagem passiva chega a
// 24h. Numa fase de correções frequentes, isso significa reabrir o app
// e continuar vendo o bug de ontem. Forçamos a checagem sempre que o
// app volta ao primeiro plano, para a próxima correção chegar no
// próximo "abrir o app", não só depois de uma checagem espontânea do
// navegador.
registerSW({ immediate: true })

function verificarAtualizacaoDoApp() {
  void navigator.serviceWorker?.getRegistration().then((registro) => registro?.update())
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') verificarAtualizacaoDoApp()
})
window.addEventListener('focus', verificarAtualizacaoDoApp)

const raiz = document.getElementById('raiz')
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html')

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={clienteQuery}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
